
export class CourseOrganization {
    id: number;
    courseOrganizationName: string;
    status: boolean;
}
